import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaAward, FaBook } from 'react-icons/fa';
import './Education.css';

const Education = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8, rotateY: -15 },
    visible: {
      opacity: 1,
      scale: 1,
      rotateY: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.05,
      y: -10,
      rotateY: 5,
      transition: {
        duration: 0.3
      }
    }
  };

  const education = [
    {
      icon: <FaGraduationCap />,
      title: "BSc Hons Computer Science",
      institution: "SLIIT City Uni",
      field: "Computer Science / Software Engineering",
      period: "2025 - 2026",
      description: "Comprehensive study of computer science fundamentals, algorithms, data structures, and software engineering principles."
    },
    {
      icon: <FaGraduationCap />,
      title: "HND in Computer Science and software Engineering",
      institution: "SLIIT CITY UNI",
      field: "Software Engineering and Emerging Technologies",
      period: "2023 - 2025",
      description: "Specializing in Software Engineering and Emerging Technologies"
    },
    {
      icon: <FaAward />,
      title: "AI and Web Development",
      institution: "Online Platform",
      field: "AI and Web Development",
      period: "2025",
      description: "Specialized training in artificial intelligence and modern web development technologies."
    },
    {
      icon: <FaBook />,
      title: "Game Development",
      institution: "CSGD",
      field: "Game Development",
      period: "2025",
      description: "Comprehensive study of game design, development frameworks, and interactive media technologies."
    },
    {
      icon: <FaGraduationCap />,
      title: "G.C.E. Advance Level",
      institution: "Thurstain collage colombo",
      field: "Physical Science",
      period: "2023",
      description: "Specialized in physical science , focusing on combined maths , phisics , and chemistry principles."
    },
    {
      icon: <FaGraduationCap />,
      title: "G.C.E. Ordinary Level",
      institution: "Presidents collage maharagama",
      field: "General Education",
      period: "2020",
      description: "Successfully completed with a strong academic foundation across multiple subjects"
    }
  ];

  return (
    <section id="education" className="education">
      <div className="container">
        <motion.div
          className="education-header"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            Education & Qualifications
          </motion.h2>
          <motion.p className="section-subtitle" variants={itemVariants}>
            My academic journey and professional development
          </motion.p>
        </motion.div>

        <motion.div
          className="education-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {education.map((edu, index) => (
            <motion.div
              key={index}
              className="education-card"
              variants={cardVariants}
              whileHover="hover"
            >
              <div className="education-icon">
                {edu.icon}
              </div>
              <div className="education-content">
                <h3>{edu.title}</h3>
                <h4>{edu.institution}</h4>
                <p className="education-field">{edu.field}</p>
                <p className="education-period">{edu.period}</p>
                <p className="education-description">{edu.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Education;

